<template>
  <dm-empty :scene="scene"></dm-empty>
</template>

<script>
  import DmEmpty from './DmEmpty'

  export default {
    name: 'DmTableEmpty',
    components: { DmEmpty },
    data () {
      return {
        // 宿主列表页实例（由 $parent 链向上定位）
        host: null
      }
    },
    mounted () {
      // 向上找宿主列表页：首个具备列表页特征（filterMode / tableError / dataSource+url）的组件实例
      let p = this.$parent
      while (p && p.$options && p.$options.name !== undefined) {
        if (p.filterMode !== undefined || p.tableError !== undefined || (p.dataSource !== undefined && p.url !== undefined)) {
          this.host = p
          break
        }
        p = p.$parent
      }
    },
    computed: {
      // 依据宿主实时状态自动切换空态场景：
      // 加载失败 → error；筛选模式 → filter；其余 → empty
      scene () {
        if (!this.host) {
          return 'empty'
        }
        if (this.host.tableError) {
          return 'error'
        }
        if (this.host.filterMode) {
          return 'filter'
        }
        return 'empty'
      }
    }
  }
</script>
